document.addEventListener('turbolinks:load', () => {
  $(function(){
    var loader = $('.loader-wrap');

    $(window).on('load',function(){
      loader.fadeOut();
    });

    setTimeout(function(){
      loader.fadeOut();
    },100);
  });
});